var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"glosses-insurance","route":"/reports/billing-glosses-insurance","file-name":"glosas-por-convenio.xlsx","columns":_vm.columns}})
}
var staticRenderFns = []

export { render, staticRenderFns }